import clsx from 'clsx'
import React, {FC, useState, useEffect} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {
  HeaderNotificationsMenu,
  HeaderUserMenu,
  QuickLinks,
  Search,
  ThemeModeSwitcher,
} from '../../../partials'
import {useLayout} from '../../core'
import i18next from 'i18next'
import Dropdown from 'react-bootstrap/Dropdown'
import {checkToken} from '../../../../api/modules/auth'
import {useNavigate} from 'react-router-dom'
import swal from 'sweetalert'
import {useIntl} from 'react-intl'
import {setLanguage} from '../../../i18n/Metronici18n'
import {NotificationTopbar} from 'src/components'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px',
  toolbarButtonIconSizeClass = 'svg-icon-1'

const Topbar: FC = () => {
  const {config} = useLayout()
  const intl = useIntl()

  const langguage = [
    {
      name: 'Eng',
      code: 'en',
      image: 'Flag_of_the_United_Kingdom.svg.webp',
    },
    {
      name: 'Idn',
      code: 'id',
      image: 'indonesia.webp',
    },
  ]

  const handleLanguageId = () => {
    i18next.changeLanguage('id')
    const btnid = document.getElementById('id')
    const btnen = document.getElementById('en')
    btnen?.classList.remove('active')
    btnid?.classList.add('active')
  }

  const handleLanguageEn = () => {
    i18next.changeLanguage('en')
    const btnid = document.getElementById('id')
    const btnen = document.getElementById('en')
    btnid?.classList.remove('active')
    btnen?.classList.add('active')
  }

  const test = document.cookie
  const cookie = test.split(';')

  // get i18next=en in cookie
  const getCookie = (name: string) => {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop()?.split(';').shift()
  }

  let language = getCookie('i18next')
  const [LanguageState, setLanguageState] = useState(language)

  const [name, setName] = useState('')
  useEffect(() => {
    // const url = window.location.href.split('token=')
    // console.log(url[1])
    // if (url[1] != undefined) {
    //   localStorage.setItem('token', url[1])
    //   const tokenCheck = async () => {
    //     // setLoading(true)
    //     await checkToken(url[1])
    //       .then((res) => {
    //         console.log(res.data)
    //         // localStorage.setItem('credential', res.data.credential)
    //         localStorage.setItem('accesses', JSON.stringify(res.data.accesses))
    //         localStorage.setItem('username', res.data.accesses?.name)
    //         if (res.data.error) navigate('/auth')
    //       })
    //       .catch((error) => {

    //       })
    //   }
    //   tokenCheck()
    // }
    const username = () => {
      const name: any = localStorage.getItem('username')
      setName(name)
    }

    username()
  }, [])

  return (
    <>
      <NotificationTopbar />
      <div className='d-flex align-items-stretch flex-shrink-0' id='topbardiv'>
        {/* begin::User */}
        <div
          className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
          id='kt_header_user_menu_toggle'
        >
          <div className='me-10'>
            <div className='btn-lang d-flex'>
              <button
                id='id'
                className={
                  language === 'id'
                    ? 'd-flex align-items-center me-1 active '
                    : 'd-flex align-items-center me-1'
                }
                onClick={handleLanguageId}
              >
                <img src={toAbsoluteUrl(`/media/flag/indonesia.webp`)} className='img-flag' />
                <h6 className='ms-1'>Ind</h6>
              </button>

              <button
                id='en'
                className={
                  language === 'en'
                    ? 'd-flex align-items-center me-1 active '
                    : 'd-flex align-items-center me-1'
                }
                onClick={handleLanguageEn}
              >
                <img
                  src={toAbsoluteUrl(`/media/flag/Flag_of_the_United_Kingdom.svg.webp`)}
                  className='img-flag'
                />
                <h6 className='ms-1'>Eng</h6>
              </button>
            </div>
          </div>
          {/* begin::Toggle */}
          <div
            className={clsx(
              'cursor-pointer symbol d-flex align-items-center',
              toolbarUserAvatarHeightClass
            )}
            data-kt-menu-trigger='click'
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='bottom'
          >
            <h6 className='me-2' style={{color: '#354C65'}}>
              Hi, {localStorage.getItem('username')}
            </h6>
            <img
              style={{borderRadius: '50%'}}
              src={`https://ui-avatars.com/api/?name=${localStorage.getItem(
                'username'
              )}&background=274070&color=fff`}
              alt='metronic'
            />
          </div>
          <HeaderUserMenu />
          {/* end::Toggle */}
        </div>
        {/* end::User */}
      </div>
    </>
  )
}

export {Topbar}
